import React from 'react';
import { Button } from 'flowbite-react';
import { useUserContext } from 'src/context/UserProvider';
import { HiExternalLink, HiOutlineClock, HiOutlineSupport } from 'react-icons/hi';

const HelpdeskSection = () => {
    const { user } = useUserContext();

    // Zoom links and timing based on role
    const helpdeskInfo = {
        CAP: {
            link: 'https://us06web.zoom.us/j/86558858929',
            timing: 'Mon - Fri (7:00 - 7:30 PM)',
        },
        IIT: {
            link: 'https://us06web.zoom.us/j/86336411337',
            timing: 'Mon - Fri (7:00 - 8:00 PM)',
        },
        MasaiStudent: {
            link: 'https://us06web.zoom.us/j/85707260795',
            timing: 'Mon - Fri (6:00 - 7:00 PM)',
        },
        MasaiAlum: {
            link: 'https://us06web.zoom.us/j/81448425087',
            timing: 'Mon - Fri (6:00 - 8:00 PM)',
        },
    };

    // Get user's subRole (case-insensitive)
    const userSubRole = user?.subRole?.toUpperCase();
    const helpdeskData = userSubRole === 'CAP'
        ? helpdeskInfo.CAP
        : userSubRole === 'IIT'
            ? helpdeskInfo.IIT
            : userSubRole === 'MasaiStudent'
                ? helpdeskInfo.MasaiStudent
                : userSubRole === 'MasaiAlum'
                    ? helpdeskInfo.MasaiAlum
            : null;

    // If no matching role, don't show the section
    if (!helpdeskData) {
        return null;
    }

    return (
        <div className="dp-rise rounded-[16px] border border-[#E8E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(20,20,60,0.04)] dark:border-gray-700 dark:bg-[#1F2A37] md:p-6">
            <div className="mb-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-[12px] bg-[#EEEDFD] text-[#4F46E5]">
                    <HiOutlineSupport className="h-5 w-5" />
                </span>
                <h2 className="text-[18px] font-[800] tracking-[-0.02em] text-[#111E2C] dark:text-white">Helpdesk</h2>
            </div>
            <div className="flex flex-col gap-3">
                <p className="text-[14px] md:text-[15px] leading-[22px] text-[#3C3E55] dark:text-[#E4E4EB]">
                    Need help? Join our helpdesk session on Zoom.
                    {/* {userSubRole && (
                        <span className="ml-1 font-medium">({userSubRole})</span>
                    )} */}
                </p>
                <div className="inline-flex w-fit items-center gap-1.5 rounded-full bg-[#F1F1F5] px-3 py-1.5 text-[13px] font-[600] text-[#3C3E55] dark:bg-[#111827] dark:text-[#E4E4EB]">
                    <HiOutlineClock className="h-4 w-4 text-[#4F46E5]" />
                    {helpdeskData.timing}
                </div>
                <Button
                    color="purplePlaced"
                    onClick={() => window.open(helpdeskData.link, '_blank')}
                    className="w-fit !rounded-[12px] !bg-gradient-to-b !from-[#5B4FF0] !to-[#3027D8] !text-white !shadow-[0_4px_12px_rgba(79,70,229,0.25)] hover:!opacity-95 disabled:!opacity-50 [&>span]:!rounded-[12px] [&>span]:!px-5 [&>span]:!py-2.5 [&>span]:!text-[14px] [&>span]:!font-[700] [&>span]:!whitespace-nowrap"
                    size="sm"
                >
                    <span className="flex items-center gap-2">
                        Join Helpdesk Session
                        <HiExternalLink className="w-4 h-4" />
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default HelpdeskSection;

